<template>
  <div class="card card-body bg-light mb-3">
    <div class="h5 mb-1 fw-bold">Prompt {{ current }} of {{ total }}</div>
    <div class="progress">
      <div
        class="progress-bar progress-bar-striped progress-bar-animated"
        role="progressbar"
        :style="`width: ${progressWidth}%`"
      ></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PromptProgress",
  props: {
    current: Number,
    total: Number
  },
  computed: {
    progressWidth() {
      // We want to show progress completed, so when `current` is 1,
      // we want to show 0% progress.
      return (100 / this.total) * (this.current - 1);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.progress {
  height: 5px;
}
</style>
